import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsDashboardsRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-dashboards',
	path: '/jira/servicedesk/assets/dashboards',
	exact: true,
};
